import { Card, Layout, Skeleton } from "antd";
const { Content } = Layout;
interface TableLayoutAntdIF {
  isLoader: boolean | undefined;
  children: any;
  style?: any;
}
const TableLayoutAntd = ({
  isLoader,
  children,
  style = {},
}: TableLayoutAntdIF) => {
  return (
    <Layout className="antdLayoutCss" style={{ ...style }}>
      <Content>
        {" "}
        {isLoader ? (
          <Card>
            <br />
            <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
            <br />
            <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
            <br />
            <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
            <br />
          </Card>
        ) : (
          <>{children}</>
        )}
      </Content>
    </Layout>
  );
};

export default TableLayoutAntd;
